/**
 * @generated SignedSource<<3a98b9bf18ae0dc6f0e5695df328cd63>>
 * @relayHash bd87bef6c1f95f4eee223a2de073f67f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 5cdf45da713eca4f7fc48c8d589271b90141e45787965c7f1519e0a2fc680408

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessBoardQuery } from './src_jiraBusinessBoardQuery.graphql';

import isSavedViewsBoardColumnSettingsEnabled_provider from '@atlassian/jira-relay-provider/src/saved-views-board-column-settings.relayprovider';
import withFiltersAndColumnSettings_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-and-column-settings.relayprovider';
import withFilters_provider from '@atlassian/jira-relay-provider/src/saved-views-board-filter-setting.relayprovider';
import withSelectedWorkflow_provider from '@atlassian/jira-relay-provider/src/saved-views-board-selected-workflow-setting.relayprovider';
import isSaveResetViewEnabled_provider from '@atlassian/jira-relay-provider/src/sv-230-save-revert-board-view-settings.relayprovider';

const node: PreloadableConcreteRequest<src_jiraBusinessBoardQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "5cdf45da713eca4f7fc48c8d589271b90141e45787965c7f1519e0a2fc680408",
    "metadata": {},
    "name": "src_jiraBusinessBoardQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardcolumnsettingsrelayprovider": isSavedViewsBoardColumnSettingsEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfiltersettingrelayprovider": withFilters_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardselectedworkflowsettingrelayprovider": withSelectedWorkflow_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsavedviewsboardfilterandcolumnsettingsrelayprovider": withFiltersAndColumnSettings_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcsv230saverevertboardviewsettingsrelayprovider": isSaveResetViewEnabled_provider
    }
  }
};

export default node;
